import MBWayPayment from "./MBWayPayment";
export default MBWayPayment;
